<script setup lang="ts">
import { onMounted } from 'vue'
import ModalConfirmation from '../UI/Modal/ModalConfirmation.vue'
import useModal from '../../../../Composables/useModal.ts'

const emit = defineEmits<{
  confirm: []
  cancel: []
}>()

const { modal, modalId, open } = useModal({ prefix: 'simulation-cancel-' })

onMounted(() => {
  open()
})
</script>

<template>
  <ModalConfirmation
    :id="modalId"
    ref="modal"
    :message="'simulation.popin.action.cancel'"
    button-confirm-title="main.bool.yes"
    button-cancel-title="main.bool.no"
    loader
    @confirm="emit('confirm')"
    @cancel="emit('cancel')"
  />
</template>
